<template lang="pug">
.div
  h2.title Locations Integration

  .form-section
    .input-container
      label.label Choose File
      input.input(ref="input" type="file" accept=".csv" autocomplete="ño" required)
      div(@click="readFile") Read File
      div {{ message }}
</template>

<script>
import gql from '@my/graphql'
import gqlLocation from '@/graphql/location'

export default {
  name: 'LocationsIntegration',

  data () {
    return {
      message: '',
      csv: '',
      titleNames: { location: 0, department: 1, envia: 2, interrapidisimo: 3, servientrega: 4, efecty: 5, baloto: 6, master: 7, visa: 8, pse: 9, amex: 10, nequi: 11, daviplata: 12, ahorro: 13, codensa: 14, bancolombia: 15, movii: 16, cod: 17, factory: 18 }
    }
  },

  methods: {
    readFile () {
      if (!this.$refs.input.files.length) return
      const file = this.$refs.input.files[0]
      const reader = new FileReader()
      this.message = 'Cargando...'
      reader.onload = () => {
        this.csv = reader.result
        this.message = 'Cargado'
        this.csvToObject()
      }
      reader.readAsText(file)
    },

    async csvToObject () {
      const _ = this.titleNames
      const lines = this.csv.split('\r\n')
      const titles = lines[0].split(';')

      for (let i = 1; i < lines.length; i++) {
        const line = lines[i]
        const values = line.split(';')
        if (!values[_.location]) continue
        const location = { location: values[_.location], department: values[_.department], active: true, availableConveyors: [], availableMethods: [] }

        if (values[_.envia]) location.availableConveyors.push(titles[_.envia])
        if (values[_.interrapidisimo]) location.availableConveyors.push(titles[_.interrapidisimo])
        if (values[_.servientrega]) location.availableConveyors.push(titles[_.servientrega])

        if (values[_.efecty]) location.availableMethods.push(titles[_.efecty])
        if (values[_.baloto]) location.availableMethods.push(titles[_.baloto])
        if (values[_.master]) location.availableMethods.push(titles[_.master])
        if (values[_.visa]) location.availableMethods.push(titles[_.visa])
        if (values[_.pse]) location.availableMethods.push(titles[_.pse])
        if (values[_.amex]) location.availableMethods.push(titles[_.amex])
        if (values[_.nequi]) location.availableMethods.push(titles[_.nequi])
        if (values[_.daviplata]) location.availableMethods.push(titles[_.daviplata])
        if (values[_.ahorro]) location.availableMethods.push(titles[_.ahorro])
        if (values[_.codensa]) location.availableMethods.push(titles[_.codensa])
        if (values[_.bancolombia]) location.availableMethods.push(titles[_.bancolombia])
        if (values[_.movii]) location.availableMethods.push(titles[_.movii])
        if (values[_.cod]) location.availableMethods.push(titles[_.cod])
        if (values[_.factory]) location.availableMethods.push(titles[_.factory])

        if (i) await this.newLocation(location)
      }
    },

    async newLocation (location) {
      const mutation = gqlLocation.NEW

      const variables = { location }

      const response = await gql.mutate(mutation, variables, false)

      if (response) {
        console.log(`The location '${location.location}' ha sido creada`)
      } else {
        console.log(`------------- The location '${location.location}' ha tenido un error al crearse`)
        console.log(response.error)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/integrations/Locations.vue